module.exports = __webpack_public_path__ + "img/ImagemUsuario.dbb6d54f.png";